export default {
  data: [
    {
      _id: '5e9664cff87ac15464c55f1b',
      content:
        'If I had a gun with two bullets and I was in a room with Hitler, Bin Laden, and Toby, I would shoot Toby twice.',
      character: {
        _id: '5e93b4a43af44260882e33b0',
        firstname: 'Michael',
        lastname: 'Scott',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e96651df87ac15464c55f1c',
      content: 'Occasionally, I’ll hit somebody with my car. So sue me.',
      character: {
        _id: '5e93b4a43af44260882e33b0',
        firstname: 'Michael',
        lastname: 'Scott',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9665856a66e65486e24491',
      content: 'Everybody stay calm! Stay fucking calm!',
      character: {
        _id: '5e93b4a43af44260882e33b0',
        firstname: 'Michael',
        lastname: 'Scott',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9665956a66e65486e24492',
      content: 'I. Declare. Bankruptcy!',
      character: {
        _id: '5e93b4a43af44260882e33b0',
        firstname: 'Michael',
        lastname: 'Scott',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e96659e6a66e65486e24493',
      content:
        'And I knew exactly what to do. But in a much more real sense, I had no idea what to do.',
      character: {
        _id: '5e93b4a43af44260882e33b0',
        firstname: 'Michael',
        lastname: 'Scott',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9665a76a66e65486e24494',
      content:
        'I feel like all my kids grew up, and then they married each other. It’s every parent’s dream.',
      character: {
        _id: '5e93b4a43af44260882e33b0',
        firstname: 'Michael',
        lastname: 'Scott',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9665af6a66e65486e24495',
      content: 'Dwight, you ignorant slut!',
      character: {
        _id: '5e93b4a43af44260882e33b0',
        firstname: 'Michael',
        lastname: 'Scott',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9665cd6a66e65486e24496',
      content: 'Well, Happy Birthday Jesus. Sorry your party’s so lame.',
      character: {
        _id: '5e93b4a43af44260882e33b0',
        firstname: 'Michael',
        lastname: 'Scott',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9665d66a66e65486e24497',
      content:
        'Sometimes I’ll start a sentence, and I don’t even know where it’s going. I just hope I find it along the way.',
      character: {
        _id: '5e93b4a43af44260882e33b0',
        firstname: 'Michael',
        lastname: 'Scott',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9665e06a66e65486e24498',
      content:
        "There are certain things a boss does not share with his employees. His salary, that would depress them. His bed, it--- And I am not going to tell them that I'll be reading their e-mails.",
      character: {
        _id: '5e93b4a43af44260882e33b0',
        firstname: 'Michael',
        lastname: 'Scott',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9665f76a66e65486e24499',
      content:
        'Once every hour, someone is involved in an internet scam. That man is Michael Scott.',
      character: {
        _id: '5e93b50a3af44260882e33b3',
        firstname: 'Pam',
        lastname: 'Beesly',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e96661b6a66e65486e2449a',
      content:
        "It's performance review day, company-wide. Last year, my performance review started with Michael asking me what my hopes and dreams were, and it ended with him telling me he could bench-press 190 pounds. So, I don't really know what to expect.",
      character: {
        _id: '5e93b50a3af44260882e33b3',
        firstname: 'Pam',
        lastname: 'Beesly',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9666296a66e65486e2449b',
      content: 'I feel God in this Chili’s tonight.',
      character: {
        _id: '5e93b50a3af44260882e33b3',
        firstname: 'Pam',
        lastname: 'Beesly',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9666336a66e65486e2449c',
      content:
        'There’s a lot of beauty in ordinary things. Isn’t that kind of the point?',
      character: {
        _id: '5e93b50a3af44260882e33b3',
        firstname: 'Pam',
        lastname: 'Beesly',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e96667c6a66e65486e2449d',
      content:
        "Two eyes. Two ears. A chin. A mouth. Ten fingers. Two nipples. A butt, two kneecaps, a penis. I've just described to you the Loch Ness monster. And the reward for his capture? All the riches in Scotland. So I have one question: Why are you here?",
      character: {
        _id: '5e93b5813af44260882e33c0',
        firstname: 'Creed',
        lastname: 'Bratton',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9666d76a66e65486e2449e',
      content: 'I am immensely proud of what I did for that turtle!',
      character: {
        _id: '5e93b5323af44260882e33b7',
        firstname: 'Kevin',
        lastname: 'Malone',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e96672e6a66e65486e2449f',
      content:
        "I wake up every morning in a bed that's too small, drive my daughter to a school that's too expensive, and then I go to work to a job for which I get paid too little. But on pretzel day? Well, I like pretzel day.",
      character: {
        _id: '5e93b54d3af44260882e33ba',
        firstname: 'Stanley',
        lastname: 'Hudson',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e96673d6a66e65486e244a0',
      content: 'Did I stutter?',
      character: {
        _id: '5e93b54d3af44260882e33ba',
        firstname: 'Stanley',
        lastname: 'Hudson',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9667836a66e65486e244a1',
      content:
        "Last year, Creed asked me how to set up a blog. Wanting to protect the world from being exposed to Creed's brain, I opened up a Word document on his computer and put an address at the top. I've read some of it. Even for the Internet, it's... pretty shocking.",
      character: {
        _id: '5e93b5183af44260882e33b4',
        firstname: 'Ryan',
        lastname: 'Howard',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9667cd6a66e65486e244a2',
      content:
        "I don't talk trash, I talk smack. They're totally different. Trash talk is hypothetical, like: Your mom is so fat she can eat the internet. But smack talk is happening like right now. Like: You're ugly and I know it for a fact 'cause I got the evidence right there.",
      character: {
        _id: '5e93b51e3af44260882e33b5',
        firstname: 'Kelly',
        lastname: 'Kapoor',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9667db6a66e65486e244a3',
      content: 'I have a lot of questions. Number one, how dare you?',
      character: {
        _id: '5e93b51e3af44260882e33b5',
        firstname: 'Kelly',
        lastname: 'Kapoor',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9668086a66e65486e244a4',
      content:
        "I had feelings today for a coworker that I haven't had in years... In my defense he was grabbing my crotch fairly aggressively at the time.",
      character: {
        _id: '5e93b4f03af44260882e33b1',
        firstname: 'Jim',
        lastname: 'Halpert',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9668186a66e65486e244a5',
      content: 'Bears, Beets, Battlestar Galactica.',
      character: {
        _id: '5e93b4f03af44260882e33b1',
        firstname: 'Jim',
        lastname: 'Halpert',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e96682a6a66e65486e244a6',
      content:
        "It's true. I'm having a party. I've got three cases of imported beer, a karaoke machine, and I didn't invite Michael. So three ingredients for a great party. And it's nothing personal, I just think that if he were there, people wouldn't be able to relax, and you know, have fun, and my roommate wants to meet everybody. Because I'm pretty sure he thinks that I'm making Dwight up. [sighs] He is very real.",
      character: {
        _id: '5e93b4f03af44260882e33b1',
        firstname: 'Jim',
        lastname: 'Halpert',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e96685a6a66e65486e244a7',
      content:
        'I wish there was a way to know you’re in the good old days, before you’ve actually left them.',
      character: {
        _id: '5e93b5453af44260882e33b9',
        firstname: 'Andy',
        lastname: 'Bernard',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e96687c6a66e65486e244a8',
      content:
        "You can't let a girl feel good about herself. It will backfire on you. Every compliment has to be backhanded. 'Oh I like your dress, but I'd like it more if you had prettier hair.'",
      character: {
        _id: '5e93b5453af44260882e33b9',
        firstname: 'Andy',
        lastname: 'Bernard',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e96688d6a66e65486e244a9',
      content:
        "I'll be the Number Two guy here in Scranton in six weeks. How? Name repetition, personality mirroring, and never breaking off a handshake. I'm always thinking one step ahead. Like a carpenter that makes stairs.",
      character: {
        _id: '5e93b5453af44260882e33b9',
        firstname: 'Andy',
        lastname: 'Bernard',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e96689a6a66e65486e244aa',
      content: 'Sorry I annoyed you with my friendship.',
      character: {
        _id: '5e93b5453af44260882e33b9',
        firstname: 'Andy',
        lastname: 'Bernard',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9668c76a66e65486e244ab',
      content:
        "Whenever I'm about to do something, I think, 'Would an idiot do that?' And if they would, I do not do that thing.",
      character: {
        _id: '5e93b4fa3af44260882e33b2',
        firstname: 'Dwight',
        lastname: 'Schrute',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9668d16a66e65486e244ac',
      content: 'It has to be official, and it has to be urine.',
      character: {
        _id: '5e93b4fa3af44260882e33b2',
        firstname: 'Dwight',
        lastname: 'Schrute',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9668dd6a66e65486e244ad',
      content:
        "I have been Michael's #2 guy for about 5 years. And we make a great team. We're like one of those classic famous teams. He's like Mozart, and I'm like Mozart's friend. No. I'm like Butch Cassidy, and Michael is like Mozart. You try and hurt Mozart; you're going to get a bullet in your head courtesy of Butch Cassidy.",
      character: {
        _id: '5e93b4fa3af44260882e33b2',
        firstname: 'Dwight',
        lastname: 'Schrute',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9668f46a66e65486e244ae',
      content:
        'I.D. badges are long overdue. Security in this office park is a joke. Last year, I came to work with my spud gun in a duffel bag. I sat at my desk all day, with a rifle that shoots potatoes at 60 pounds per square inch. Can you imagine if I was deranged?',
      character: {
        _id: '5e93b4fa3af44260882e33b2',
        firstname: 'Dwight',
        lastname: 'Schrute',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9669256a66e65486e244af',
      content: 'If you pray enough, you can change yourself into a cat person.',
      character: {
        _id: '5e93b52b3af44260882e33b6',
        firstname: 'Angela',
        lastname: 'Martin',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9669396a66e65486e244b0',
      content:
        'I know that patience and loyalty are good, and virtuous traits. But sometimes I just think you need to grow a pair.',
      character: {
        _id: '5e93b52b3af44260882e33b6',
        firstname: 'Angela',
        lastname: 'Martin',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9669a26a66e65486e244b1',
      content:
        "I didn't realize how many of Angela's opinions I agreed with...until she tried to have my knee caps shattered for sleeping with her husband.",
      character: {
        _id: '5e93b53b3af44260882e33b8',
        firstname: 'Oscar',
        lastname: 'Martinez',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e9669d06a66e65486e244b2',
      content:
        "I'm glad Michael's getting help. He has a lot of issues, and he's stupid.",
      character: {
        _id: '5e93b5583af44260882e33bb',
        firstname: 'Phyllis',
        lastname: 'Lapin',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e966a166a66e65486e244b3',
      content:
        "Chad Flenderman. Just an easy-going black guy who knows the streets--yet he also went to Oxford. So. Just as comfortable on a motorcycle as he is on Air Force One. Oh and he's also the world's leading Egyptologist.",
      character: {
        _id: '5e93b55f3af44260882e33bc',
        firstname: 'Toby',
        lastname: 'Flenderson',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e966a376a66e65486e244b4',
      content:
        "Disposable cameras are fun, but it seems a little wasteful. You never get to see your pictures. If it's an important event that you want to remember, I recommend using a real camera.",
      character: {
        _id: '5e93b5653af44260882e33bd',
        firstname: 'Erin',
        lastname: 'Hannon',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e966a526a66e65486e244b5',
      content: 'Shut up about the sun. SHUT UP ABOUT THE SUN!',
      character: {
        _id: '5e93b56d3af44260882e33be',
        firstname: 'Gabe',
        lastname: 'Lewis',
        __v: 0,
      },
      __v: 0,
    },
    {
      _id: '5e966a676a66e65486e244b6',
      content:
        "In a gang world, we use something called fluffy fingers. That's when someone really gets in your face, you know you just, start ticklin' 'em. And he starts tickling you. And pretty soon you laughing and hugging. Before you know it, you've forgotten the whole thing. Y'all just go to church together, and get an ice cream cone.",
      character: {
        _id: '5e93b5783af44260882e33bf',
        firstname: 'Darryl',
        lastname: 'Philbin',
        __v: 0,
      },
      __v: 0,
    },
  ],
}
